<template>
  <div class="card">
    <v-chart
      :title="title"
      :option="chartOptions"
      style="width: 600px; height: 260px;"
    ></v-chart>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    model: {
      type: Array,
      required: true
    },
    preventive: {
      type: Boolean,
      default: false
    },
    corrective: {
      type: Boolean,
      default: false
    },
    maintanceType: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "v-chart": ECharts
  },
  computed: {
    chartOptions() {
      const title_color = this.$store.state.darkmode ? "#FFFFFF" : "#000000";

      let colorMapping = {};

      if (this.preventive) {
        colorMapping = {
          "Em Dia": "#28a745",
          "Próximo da Troca": "#ffc107",
          Vencido: "#dc3545"
        };
      } else if (this.corrective) {
        colorMapping = {
          "Em Manutenção": "#dc3545",
          Programada: "#597aff",
          Finalizada: "#28a745"
        };
      } else if (this.maintanceType) {
        colorMapping = {
          Corretiva: "#597aff",
          Sinistro: "yellow",
          Preventiva: "#28a745"
        };
      } else {
        console.warn(
          "PieEChart: Defina apenas uma das props 'preventive' ou 'corrective' como true."
        );
        colorMapping = {};
      }

      const dataWithColors = this.model.map(item => ({
        ...item,
        itemStyle: {
          color: colorMapping[item.name] || "#cccccc"
        }
      }));

      return {
        title: {
          text: this.title,
          left: "center",
          top: "0%",
          textStyle: {
            color: title_color,
            fontSize: 20
          }
        },
        legend: {
          orient: "horizontal",
          left: "center",
          top: "10%",
          itemGap: 20,
          textStyle: {
            color: title_color,
            fontSize: 14
          }
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "60%"],
            center: ["50%", "62%"],
            label: {
              formatter: "{c} ({d}%)",
              color: title_color,
              fontSize: 14
            },
            data: dataWithColors
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.card {
  width: 100%;
  max-width: 100%;
  padding: 15px;
  background-color: #1e1e2f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212);
  border-radius: 14px;
  transition: transform 0.3s, box-shadow 0.3s;
  overflow: hidden;
  align-items: center;
  border-color: #ffffff;
  border: 1px solid;
}
</style>
